<template>
  <div class="product-item" :class="activeClass ? 'product-item_active' : ''">
    <div class="product-item__image-wrap">
      <img :src="item.first_image.id !== null ? item.first_image.thumb_url : emptyImageUrl" class="product-item__image" alt="">
    </div>
    <div class="product-item__content-wrap">
      <a :href="`//${shopUrl + item.url}`">{{item.title}}</a>
      <span>{{ item.variants[0].price }}</span>
    </div>
    <div class="product-item__button-wrap">
      <div @click="change(item.variants[0].id)" class="product-item__button">Выбрать</div>
    </div>
    <div class="product-item__variants">
      <div @click="change(variant.id)" class="product-item__variant" :data-variant-id="variant.id" v-for="variant in item.variants" :key="variant.id">
        <div class="product-item__option" v-for="opt in variant.option_values" :key="opt.id">
          {{ opt.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-item',
  props: {
    item: {
      type: Object
    },
    shopUrl: {
      type: String
    }
  },
  methods: {
    emitItem: function (variantId) {
      const currentVariant = this.item.variants.find(variant=> variant.id == variantId);
      const param = {};
      this.item.option_names.forEach(option_name => {
        param[option_name.title] = currentVariant.option_values.find(option_value => option_value.option_name_id === option_name.id).title
      })
      const productModeParamsKeys = this.item.option_names.map(option_names => option_names.title).join(',')
      this.$emit('change', {
        productId: this.item.id,
        variantId,
        product_mode_params: param,
        product_mode_params_keys: productModeParamsKeys,
        categoryId:this.item.category_id,
        itemData: {
          title: this.item.title,
          mode: `${currentVariant.option_values.map(item => `${item.title}`)}`,
          url: `//${this.shopUrl + this.item.url}`
        }
      })
    },
    change: function (variantId) {
      this.emitItem(variantId);
    },
    openVariant: function () {
      this.activeClass = true;
    }
  },
  computed: {
    emptyImageUrl: function () {
      return `${window.location.origin}${this.emptyImage}`
    }
  },
  data: function () {
    return {
      emptyImage: require('../../assets/icons/empty.png'),
      activeClass: false
    };
  }
}
</script>
<style lang="scss">
.product-item {
  display: flex;
  justify-content: space-between;
  border-radius: 20px;
  border: 1px solid var(--color-border);
  overflow: hidden;
  margin: 5px 0;
  position: relative;
  &__image-wrap {
  }
  &__image {
    width: 60px;
    height: 100%;
    min-height: 70px;
    object-fit: cover;
    display: block;
  }
  &__content-wrap {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 10px;
    & a {
      color: var(--color-dark);
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 3px;
    }
  }
  &__button-wrap {
    padding-left: 10px;
    margin-left: 10px;
    border-left: 1px solid var(--color-border);
  }
  &__button {
    cursor: pointer;
    background-color: var(--color-violet);
    color: #F8F8FB;
    height: 100%;
    min-height: 70px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 10px;
    &:hover {
      background-color: var(--color-violet-dark);
    }
  }
  &__variants {
    position: absolute;
    display: flex;
    align-items: center;
    left: 100%;
    transition: .5s;
    background-color: rgba(255, 255, 255, .97);
    width: 100%;
    height: 100%;
    padding: 10px;
    overflow-x: scroll;
  }
  //&__variant {
  //  font-size: 12px;
  //  font-weight: 600;
  //  display: flex;
  //  flex-direction: column;
  //  align-items: center;
  //  justify-content: center;
  //  border: 2px solid var(--color-dark);
  //  border-radius: 15px;
  //  padding: 5px;
  //  margin-right: 5px;
  //  text-align: center;
  //}
  &__variant {
    font-size: 11px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
    text-align: center;
    min-width: 100px;
    max-width: 140px;
    height: 100%;
    border: none;
    border: 1px solid var(--color-dark);
    border-radius: 10px;
    margin-right: 4px;
    padding: 0 10px;
    cursor: pointer;
  }
  &_active {
    .product-item__variants {
      left: 0;
      transition: .5s;
    }
  }
}
</style>